import { render, staticRenderFns } from "./Lista-Dottori.vue?vue&type=template&id=cdce3aea&scoped=true&"
import script from "./Lista-Dottori.vue?vue&type=script&lang=js&"
export * from "./Lista-Dottori.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Dottori.vue?vue&type=style&index=0&id=cdce3aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdce3aea",
  null
  
)

export default component.exports